interface RenderIf {
  isTrue: boolean
  children: React.ReactNode
}
const RenderIf: React.FC<RenderIf> = ({ isTrue, children }) => {
  return isTrue ? <>{children}</> : <></>
}
export default RenderIf
